/**
 * Where to send someone who wants the app.
 *
 * One place rather than a literal at each call site: the store URLs appear in
 * the promo modal, the download page, the shared-link banner, the shared-link
 * fallback and the Schema.org `MobileApplication` blocks, and a store listing
 * that moves has to move in all of them at once.
 */

export const APP_STORE_URL = 'https://apps.apple.com/us/app/centmap/id6469340143';

/** Numeric half of the App Store id, for Safari's own smart app banner. */
export const APP_STORE_ID = '6469340143';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.centmap.app';

/** Play Store package name, mirroring `.well-known/assetlinks.json`. */
export const ANDROID_PACKAGE = 'com.centmap.app';

/**
 * The store this visitor most likely wants, for the places that have room for
 * one button rather than two.
 *
 * Deliberately coarse: it only has to answer "Android or not", and the answer
 * only decides which store a link opens — never what is rendered — so it is
 * safe to read during render and costs nothing if a rare browser lies.
 */
export function preferredStoreUrl(): string {
  if (typeof navigator === 'undefined') return APP_STORE_URL;
  return /android/i.test(navigator.userAgent) ? PLAY_STORE_URL : APP_STORE_URL;
}
